<template>
	<div
		class="property-form"
		:class="{ 'shrink': !isVisible, 'bg-color-editing': isUserEditing !== user.id && isUserEditing }">
		<div class="d-flex align-items-start justify-content-between">
			<div v-if="isLoading" class="absolute loader-circle">
				<div class="is-loading"></div>
			</div>
			<div class="property-title">
				{{ $t('Ticker Properties') }} - {{  label ? label.toUpperCase()  : 'Default Ticker' }}
			</div>
		</div>
		<!-- <transition name="fade"> -->
			<div class="property-content pr-2" :class="{'pointer-events-none': isLocked	? isLocked.is_locked   : true}">
				<div class="property-rundown-wrapper custom-scroll pr-2 ">
					<div class="form-group mb-0">
						<label class="text-primary">{{ $t('Ticker Property') }}</label>

						<div class="form-group mb-3 ">
							<custom-input
								class="mb-3"
								align="left"
								:label="$t('Label')"
								:required="isRequired"
								v-model="label"
								:max="40"
								:restrictChar="true"
							/>
						</div>
						<div class="form-group mb-4 ">
							<custom-input
								class="mb-3"
								align="left"
								:label="$t('Title')"
								v-model="title"
								:restrictChar="true"
							/>
						</div>
						<div class="row row-thin">
							<!-- Speed -->
							<div class="col-md-6 pr-1 mr-0">
								<custom-input
									class="mb-3"
									align="left"
									:label="$t('Speed')"
									:required="isRequired"
									:max="200"
									type="number"
									v-model="speed"
								/>
							</div>
							<div class="col-md-6 pl-1">
								<custom-input
									type="number"
									class="form-control"
									field="index"
									:label="$t('Layer')"
									:required="isRequired"
									:max="100"
									:index-duplicated="isIndexDuplicated"
									v-model="layerIndex"
								/>
							</div>
						</div>
						<div class="col-md-6 pl-0 pr-1 mb-3">
							<custom-input
								type="number"
								:label="$t('Opacity')"
								:required="isRequired"
								:min="0"
								:max="100"
								:step="1"
								:suffix="'%'"
								v-model="opacity"
							/>
						</div>
						<div class="row row-thin">
							<div class="col-12">
								<div class="d-flex justify-content-between">
									<label class="label text-secondary">{{ $t('Ticker Data') }}</label>
									<label class="label text-grey">{{ $t('Type and press enter to save, and repeat') }}</label>
								</div>
								<md-chips
									class="ticker-input form-control ticker-chip"
									v-model="tickerData"
									@md-delete="onKeywordChange"
									@md-insert="onKeywordChange"
									:md-limit="limit">
									<template slot="md-chip" slot-scope="{ chip }">
										{{ chip }}
									</template>
								</md-chips>
							</div>
						</div>
					</div>
					<!-- button for upload assets ticker -->
					<div class="form-group mb-1 d-flex">
						<!-- Upload -->
						<label
							:class="{'is-loading': isUploadingAsset}"
							class="btn min-w-100 btn-primary mb-0 mh-36">
							<span v-if="!mediaAssetLabel && !isUploadingAsset" class="text-black">{{ $t('Upload Ticker Data (.xml or .json)') }}</span>
							<div v-if="mediaAssetLabel && !isUploadingAsset" class="text-black ">Uploaded ({{ mediaAssetLabel }})</div>
							<input
								accept=".json, .xml"
								type="file"
								class="hidden"
								@change="onSelectedTicker"
								id="tickerDataInput"
							/>
						</label>
					</div>
					<div class="text-secondary mb-3">
						Download example <a href="./../../template-xlsx/EXAMPLE_XML_TICKER.xml" download>{{ $t('.XML') }}</a> or <a href="./../../template-xlsx/EXAMPLE_JSON_TICKER.json" download>{{ $t('.JSON') }}</a> file
					</div>
					<!-- Ticker Style -->
					<div class="form-group">
						<label class="text-primary">{{ $t('Ticker Style') }} </label>
						<div class="row row-thin">
							<!-- Font Color -->
							<div class="col-md-6 pr-1">
								<custom-input
									type="color"
									class="mb-3"
									align="left"
									:label="$t('Color')"
									:placeholder="$t('Color')"
									:required="isRequired"
									v-model="fontColor"
								/>
							</div>
							<div class="col-md-6 pl-1">
								<custom-input
									type="color"
									class="mb-2"
									align="left"
									picker-position="right"
									:label="$t('BG Color')"
									:placeholder="$t('BG Color')"
									:required="isRequired"
									v-model="backgroundColor"
								/>
							</div>
							<div class="col-md-6 mb-3">
								<md-menu md-align-trigger md-direction="bottom-start" class="w-100" :md-active.sync="isToggleFont">
									<div md-menu-trigger class="w-100">
										<custom-input
											v-if="fontStyle >= 0 && fontStyle !== ''"
											type="selectSearch"
											class="form-control cur-p relative"
											:label="$t('Font')"
											:value="labelFont"
											@remove="removeFont()"
											:showClose="true"
											:align="'left'"
										/>
										<div @click.stop="toggleFont">
											<custom-input
												v-click-outside="resetFont"
												v-if="fontStyle === ''"
												type="selectSearchEmpty"
												class="form-control cur-p relative capitalize"
												:label="$t('Font')"
												v-model="searchFont"
												:showClose="false"
												:align="'left'"
											/>
										</div>
									</div>
									<md-menu-content id="scrolls-style" class="assets-item-wrapper-list ">
										<md-menu-item class="assets-item-wrapper-list item-property-rundown" v-for="item in filteredFont" @click="fontStyle = parseInt(item.key)"
											:key="item.key">{{item.label}}
										</md-menu-item>
										<md-menu-item v-if="filteredFont.length <= 0" class="assets-item-wrapper-list item-property-rundown">
											Not available
										</md-menu-item>
									</md-menu-content>
								</md-menu>
							</div>
							<div class="col-md-6 pl-1">
								<custom-input
										type="number"
										:label="$t('Angle')"
										:required="isRequired"
										:max="360"
										:disable="!gradient"
										v-model="angle"
										class="form-control "
									/>
							</div>
							<div class="col-md-6">
								<md-switch
									class="md-primary mt-2 mb-2 mr-0 absolute ml-10px"
									v-model="gradient">
									<span>{{ $t('Gradient Background') }}</span>
								</md-switch>
							</div>
							<div class="col-md-6">
								<md-switch
									class="md-primary mt-2 mb-2 mr-4 "
									v-model="hardGradient">
									{{ $t('Hard Gradient ') }}
								</md-switch>
							</div>
							<div class="col-md-6">
								<md-switch
									class="md-primary mt-0 mb-2 mr-4 "
									v-model="displayTime">
									{{ $t('Display Time') }}
								</md-switch>
							</div>
						</div>
					</div>

					<!-- Position Settings -->
					<div class="form-group mt-1">
						<position-settings
							class="mb-3"
							:width.sync="width"
							:height.sync="height"
							:position.sync="position"
							:x.sync="x"
							:y.sync="y"
							:isRatio.sync="isRatio"
							:isPosition.sync="isPosition"
							@reset="resetSizePosition"
							:blendmode.sync="blendMode"
							:isBlendActive="isBlendActive"
							:type="'ticker'"
							@rescale="rescaleSize"
						/>
					</div>
					<!-- parent controller -->
					<div class="mt-2">
					<div class="d-flex justify-content-between">
						<div>
							<label class="text-primary">{{ $t('Parent Controller') }}</label>
						</div>
						<div class="ml-0 pl-0">
							<md-switch
								class="md-primary mt-0 mb-2 mr-0"
								v-model="isParent">
							</md-switch>
						</div>
					</div>
					</div>
					<div class="d-flex select ">
						<!-- new dropdown select assets -->
						<md-menu
							:md-active.sync="isToggleParent"
							class="h-fc mr-2 w-100"
							md-size="small"
							md-direction="top-start"
							md-align-trigger>
							<div v-if="selectedParent"
								class="form-control cur-p relative w-100"
								md-menu-trigger>
								<item-option
									:item="selectedParent"
									v-if="selectedParent"
								/>
								<div @click.stop="removeParent" class="modal-close-assets absolute delete-assets-add">
									<i class="material-icons">cancel</i>
								</div>
							</div>
							<div v-else md-menu-trigger>
								<input
									type="text"
									class="form-control w-100"
									:placeholder="$t('Search or Select Parent Item')"
									v-model="keywordSearchParent"
									@click.stop="toggleParent"
								/>
								<item-option
									:item="selectedParent"
									v-if="selectedParent"
								/>
							</div>
							<md-menu-content id="scrolls-style"
							:class="{'macro-content-wrapper-list': filteredParent.length > 6, 'assets-wrapper-list-empty': filteredParent.length === 0,
								'assets-wrapper-list-1': filteredParent.length === 1, 'assets-wrapper-list-2': filteredParent.length === 2,
								'assets-wrapper-list-3': filteredParent.length === 3, 'assets-wrapper-list-4': filteredParent.length === 4,
								'assets-wrapper-list-5': filteredParent.length === 5, 'assets-wrapper-list-6': filteredParent.length === 6,
								}"
								>
								<md-menu-item class="item-macros-rundown macro-content-wrapper-list"
									v-for="rundownItem in filteredParent"
									:key="rundownItem.id"
									@click="selectParent(rundownItem)">
									<item-option :item="rundownItem" />
								</md-menu-item>
								<md-menu-item v-if="filteredParent.length <= 0" class="item-macros-rundown macro-content-wrapper-list">
									Oops, there is no assets available
								</md-menu-item>
							</md-menu-content>
						</md-menu>
						<!-- delay -->
						<div class="select">
							<custom-input
								class="form-input"
								type="number"
								:label="$t('Delay')"
								:min="-15000"
								:max="15000"
								:step="100"
								:suffix="'ms'"
								v-model="childOrder"
								:allowNegative="true"
							/>
						</div>
					</div>
					<div class="d-flex mt-4">
						<button @click="save()"
							:class="{ 'is-loading': isSaving }"
							class="btn btn-primary btn-sm mr-2">
							{{ $t('Save Changes') }}
						</button>
						<button @click="closeForm()"
							class="btn btn-secondary btn-sm">
							{{ $t('Cancel') }}
						</button>
					</div>
				</div>
				
			</div>
		<!-- </transition> -->
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';
import parser from 'fast-xml-parser';
// import Multiselect from 'vue-multiselect';
import ClickOutside from 'vue-click-outside';
import ItemOption from '@/components/ItemOption.vue';
import { delay, duplicateVar, getAxiosErrorMessage } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import fileApi from '@/api/file';
import CustomInput from '@/components/CustomInput.vue';
import PositionSettings from '@/components/PositionSettings.vue';

import {
	fontOptions,
	delayList,
} from '@/lib/statics';

export default {
	name: 'TickerProperty',
	props: {
		data: {
			type: Object,
		},
		rundown: {
			type: Object,
		},
		template: {
			type: Object,
		},
		filteredItems: {
			type: Array,
		},
		items: {
			type: Array,
			default: () => [],
		},
	},
	components: {
		CustomInput,
		PositionSettings,
		// Multiselect,
		ItemOption,
	},
	data() {
		return {
			fontOptions,
			templateFile: '',
			templates: [],
			tickerData: [],
			fontColor: '#FFFFFF',
			backgroundColor: '#333333',
			selectedTemplate: null,
			gradient: false,
			displayTime: false,
			hardGradient: false,
			angle: 0,
			speed: 5,
			label: '',
			title: '',
			fontStyle: 0,
			layerIndex: 0,
			width: 0,
			height: 0,
			position: '',
			opacity: 100,
			x: 0,
			y: 0,
			Type: 'ticker',
			progress: 0,
			isUploading: false,
			isSaving: false,
			isVisible: true,
			limit: 50,
			currentTicker: '',
			isLoading: false,
			// color picker
			isshowColorPickerFontColor: false,
			isshowColorPickerBgColor: false,
			isRequired: false,
			isRatio: true,
			isPosition: false,
			isActiveEdit: false,
			parentItem: null,
			isParent: false,
			delayList,
			childOrder: 0,
			selectedParent: null,
			selectedOnComplete: null,
			keywordSearchParent: '',
			keywordSearchOnComplete: '',
			isToggleParent: false,
			isOnComplete: false,
			isToggleFont: false,
			blendMode: 'normal',
			isBlendActive: true,
			// upload json
			mediaAssetLabel: '',
			mediaAsset: '',
			extractedTicker: '',
			isUploadingAsset: '',
			mediaProgress: 0,
			uploadLimit: '',
			isEnableUploadLimit: false,
			settings: null,
			fileSize: '',
			mediaProgressAsset: '',
		};
	},
	directives: {
		ClickOutside,
	},
	mounted() {
	},
	methods: {
		closeForm() {
			this.$emit('close');
		},
		toggleFont() {
			this.isToggleFont = true;
		},
		toggleParent() {
			this.isToggleParent = true;
		},
		toggleOnComplete() {
			this.isOnComplete = true;
		},
		updateActiveEdit() {
			this.isSaving = true;
			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
			};
			const errorCallback = () => {
				this.isSaving = false;
			};
			const params = {
				active_edit: null,
			};
			rundownItemsApi.update(this.data.id, params, callback, errorCallback);
		},
		playPreview() {
			if (this.data.is_Locked) return; // Disable when ed
			const id = this.data.id;
			const status = 'preview';
			const callback = () => {
				// const items = response.data;
			};
			const errorCallback = () => {
			};
			const userActivateAllItem = this.userSettings && this.userSettings.is_enable_all_preview ? this.userSettings.is_enable_all_preview : false;
			const params = {
				isAllItem: userActivateAllItem,
			};
			rundownItemsApi.togglePlay(id, status, params, callback, errorCallback);
		},
		hasProperty(obj, prop) {
			return Object.prototype.hasOwnProperty.call(obj, prop);
		},
		initData() {
			this.isVisible = true;
			this.reset();
			if (this.data) {
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
				}
				this.label = this.data.name;
				this.layerIndex = this.data.layer_index;

				if (content) {
					if (content.template) {
						this.selectedTemplate = content.template;
						this.$emit('setTemplate', this.selectedTemplate);
						// this.lottiedatachange(this.selectedTemplate);
					}
					if (content.tickerData) {
						this.tickerData = content.tickerData;
					}
					this.speed = content.speed;
					this.fontColor = content.fontColor;
					this.backgroundColor = content.backgroundColor;
					this.gradient = content.gradient;
					this.opacity = content.opacity * 100;
					this.angle = content.angle;
					this.width = content.width;
					this.height = content.height;
					this.position = content.position;
					this.isRatio = content.isRatio;
					this.isPosition = content.isPosition;
					this.x = content.x;
					this.y = content.y;
					this.displayTime = content.displayTime;
					this.hardGradient = content.hardGradient;
					this.title = content.title;
					this.fontStyle = content.fontStyle;
					this.isParent = content.isParent || false;
					// this.parentItem = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedParent = this.filteredParent.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';
					this.childOrder = content.childOrder || 0;
					this.blendMode = content.blendMode;
					// uploaded ticker data
					this.mediaAssetLabel = content.mediaAssetLabel;
					this.mediaAsset = content.assetsURL;
					this.extractedTicker = content.extractedTicker;
				}
			}
		},
		reset() {
			this.selectedTemplate = null;
			this.speed = 10;
			this.tickerData = [];
			this.label = '';
			this.fontColor = '#FFFFFF';
			this.backgroundColor = '#333333';
			this.gradient = false;
			this.angle = 0;
			this.layerIndex = 0;
			this.width = 1920;
			this.height = 1080;
			this.displayTime = false;
			this.hardGradient = false;
			this.title = '';
			this.fontStyle = 0;
			this.position = 'default';
			this.x = 0;
			this.y = 0;
			if (this.template) {
				this.selectedTemplate = this.template;
			}
			this.blendMode = 'normal';
			this.mediaAssetLabel = '';
			this.extractedTicker = '';
			this.opacity = 100;
		},
		onKeywordChange() {
			delay(() => {
			}, 1200);
		},
		saveHardGradient() {
			if (this.hardGradient) {
				this.gradient = true;
			}
		},
		saveGradient() {
			if (!this.gradient) {
				this.hardGradient = false;
			}
		},
		save() {
			this.isSaving = true;

			const callback = (response) => {
				const item = response.data;
				this.$emit('add', item);
				this.isSaving = false;
				this.closeForm();
			};
			const errorCallback = () => {
				this.isSaving = false;
				this.closeForm();
			};
			if (this.data) {
				rundownItemsApi.update(this.data.id, this.tickerParams, callback, errorCallback);
			} else {
				rundownItemsApi.create(this.tickerParams, callback, errorCallback);
			}
		},
		openTemplate() {
			this.$emit('browse');
		},
		checkDuplicateIndex() {
			const valueArr = this.filteredItems.map(a => a.layer_index);
			let count = 0;
			for (let i = 0; i < valueArr.length; ++i) {
				if (valueArr[i] === this.layerIndex) count++;
			}
			if (count > 1) {
				return true;
			}
			return false;
		},
		duplicateLayerText() {
			const text1 = 'Other item also using this layer, only one item at a time will be displayed';
			return text1;
		},
		resetSizePosition() {
			this.x = 0;
			this.y = 0;
			this.position = 'default';
			this.width = 1920;
			this.height = 1080;
		},
		selectParent(item) {
			this.selectedParent = item;
			this.keywordSearchParent = '';
		},
		removeParent() {
			this.selectedParent = null;
			this.keywordSearchParent = '';
		},
		selectOnComplete(item) {
			this.selectedOnComplete = item;
			this.keywordSearchOnComplete = '';
		},
		removeOnComplete() {
			this.selectedOnComplete = null;
			this.keywordSearchOnComplete = '';
		},
		onInputEnter(props, value) {
			if (props === 'layer') this.layerIndex = value;
			if (props === 'delay') this.childOrder = value;
			if (props === 'speed') this.speed = value;
			if (props === 'angle') this.angle = value;
			if (props === 'opacity') this.opacity = value;
		},
		removeFont() {
			this.fontStyle = '';
		},
		resetFont() {
			this.searchFont = '';
		},
		onSelectedTicker(e) {
			this.initDataUser();
			const oneMB = 1048576; // MB
			if (!this.isEnableUploadLimit) {
				this.uploadLimit = 1048; // make it "1gb" when no limiter is set
			}
			let files = e.target.files;
			const fileSizeInMb = files[0].size / oneMB;
			const oneGB = 1048;
			if (files.length > 0) {
				if (files[0].type.includes('json') || files[0].type.includes('xml')) {
					if (fileSizeInMb <= oneGB) {
						if (fileSizeInMb <= this.uploadLimit) {
						// check storage
							if (this.rundownStorage && !this.isSuperAdmin) {
								const isRemainingStorageAvailable = this.rundownStorage.total_remaining_size >= 0 && this.rundownStorage.total_remaining_size >= (files[0].size / oneMB);
								const nomalizedTotalRemaining = this.rundownStorage.total_remaining_size <= 0 ? 0 : this.rundownStorage.total_remaining_size;
								if (!isRemainingStorageAvailable) {
									const message = `Your total used Storage is ${this.rundownStorage.total_used_file_size} MB, your currennt remaining size is ${nomalizedTotalRemaining.toFixed(2)}MB`;
									this.$notify({
										group: 'app',
										type: 'warning',
										title: 'Upload Lyric',
										text: message,
									});
									files = null;
									if (document.querySelector('#tickerDataInput')) document.querySelector('#tickerDataInput').value = '';
									return;
								}
								// eslint-disable-next-line no-else-return
							}
							const file = files[0];
							if (!file) {
								this.$notify({
									group: 'app',
									type: 'warn',
									title: 'Upload Lyric',
									text: 'Sorry, currently we cant upload the file',
								});
								return;
							}
							this.isUploadingAsset = true;
							const params = new FormData();
							params.append('file', file);
							if (this.rundown && this.rundown.id) params.append('rundown_id', this.rundown.id);
							this.fileSize = files.size / oneMB;
							const callback = (response) => {
								const mediaAsset = response.data;
								this.mediaAsset = mediaAsset;
								this.mediaProgressAsset = 0;
								// if upload success then get the json/xml file and save to extractedTicker in content assets (audio)
								axios
									.get(mediaAsset)
									.then((response) => {
										// if file is json
										if (response.data && response.data.tickerData) {
											this.extractedTicker = response.data && response.data.tickerData ? response.data.tickerData : '-';
											this.tickerData = this.extractedTicker;
											// if file is xml
										} else if (response.data && response.data.includes('</tickerData>')) {
											const result = response.data;
											const jsonObj = parser.parse(result);
											const finalResult = jsonObj && jsonObj.tickerData && jsonObj.tickerData.tickerText ? jsonObj.tickerData.tickerText : 'Grafias';
											this.tickerData = finalResult;
											// if file has wrong format, does not match the existing template
										} else {
											this.tickerData = '-';
										}
										// then save extractedTicker on content assets (audio)
									})
									.catch(() => {
										// show toaster error upload
										this.$notify({
											group: 'app',
											type: 'error',
											title: 'Upload Ticker',
											text: 'Looks like you uploaded .XML / .JSON with the wrong format',
										});
										if (document.querySelector('#tickerDataInput')) document.querySelector('#tickerDataInput').value = '';
										this.mediaAssetLabel = '';
									});
								this.isUploadingAsset = false;
							};
							const errorCallback = (e) => {
								const message = getAxiosErrorMessage(e);
								this.$notify({
									group: 'app',
									type: 'error',
									title: 'Upload Media',
									text: message,
								});
								this.isUploadingAsset = false;
							};
							const progressCallback = (progress) => {
								this.mediaProgressAsset = progress;
							};
							fileApi.upload(params, callback, errorCallback, progressCallback);
							// Remove extension from filename to set label
							let filename = duplicateVar(file.name);
							filename = filename.split('.').slice(0, -1).join('.');
							this.mediaAssetLabel = duplicateVar(filename);
						} else {
							files = null;
							if (document.querySelector('#tickerDataInput')) document.querySelector('#tickerDataInput').value = '';
							const appUrl = process.env.VUE_APP_URL;
							this.$notify({
								group: 'app',
								type: 'error',
								text: `You current package upload limit is ${this.uploadLimit} MB, <a href="${appUrl}/settings?menu=subscribe"> Upgrade your subscription </a>`,
							});
						}
					} else {
						files = null;
						if (document.querySelector('#tickerDataInput')) document.querySelector('#tickerDataInput').value = '';
						this.$notify({
							group: 'app',
							type: 'error',
							text: 'Max upload limit is 1GB',
						});
					}
				} else {
					this.$notify({
						group: 'app',
						type: 'warning',
						title: 'Upload Media',
						text: 'Unsupported file',
					});
					// eslint-disable-next-line
					return;
				}
			}
		},
		initDataUser() {
			if (this.user) {
				const settingsString = this.user && this.user.settings ? this.user.settings : '';
				const settings = JSON.parse(settingsString);
				this.settings = settings;
				// const roles = this.user && this.user.roles ? this.user.roles : [];
				const isSuperAdmin = this.isSuperAdmin || null;// check the computed import the getters befor implement
				const isCollaborator = this.isCollaborator || null;// check the computed import the getters befor implement
				const isClient = this.isClient || null;// check the computed import the getters befor implement
				if (!isSuperAdmin && isClient) { // not admin and can be collaborator and client who have two roles
					this.isEnableUploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.is_enabled ? duplicateVar(settings.subscription.storage.is_enabled) : false;
					this.uploadLimit = settings
					&& settings.subscription
					&& settings.subscription.storage
					&& settings.subscription.storage.upload_size ? duplicateVar(settings.subscription.storage.upload_size) : 10;
				} else if ((!isSuperAdmin && isCollaborator && !isClient)) { // only for collaborator that invited by client
					if (this.localClientUser) {
						const userClientSettingsString = this.localClientUser && this.localClientUser.settings ? this.localClientUser.settings : '';
						const userClientSettings = JSON.parse(userClientSettingsString);
						this.isEnableUploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.is_enabled ? duplicateVar(userClientSettings.subscription.storage.is_enabled) : false;
						this.uploadLimit = userClientSettings
						&& userClientSettings.subscription
						&& userClientSettings.subscription.storage
						&& userClientSettings.subscription.storage.upload_size ? duplicateVar(userClientSettings.subscription.storage.upload_size) : 10;
					}
				} else { // for superadmin only
					this.isEnableUploadLimit = false;
					this.uploadLimit = 1048;
				}
			}
		},
		rescaleSize() {
			if (this.data.content && this.rundown) {
				const displayWidth = this.rundown.display && this.rundown.display.displaySize.width ? this.rundown.display.displaySize.width : 1920;
				const displayHeight = this.rundown.display && this.rundown.display.displaySize.height ? this.rundown.display.displaySize.height : 1080;
				const spaceCanvasWidth = displayWidth - this.width;
				const spaceCanvasHeight = displayHeight - this.height;
				this.position = 'custom';
				// calculate width and height to keeping the aspect ratio based on the output size on rundown
				const ratioOriginal = Math.min(displayWidth / 1920, displayHeight / 1080);
				// check condition if image not fill canvas & not fit to canvas
				if (((spaceCanvasWidth === 0 && spaceCanvasHeight === 0) || (this.mediaX === 0 && this.mediaY === 0)) || ((this.height !== 1920 * ratioOriginal) && (this.height !== 1080 * ratioOriginal))) {
					this.width = 1920 * ratioOriginal;
					this.height = 1080 * ratioOriginal;
					// change position
					this.x = (displayWidth - this.width) / 2;
					this.y = (displayHeight - this.height) / 2;
				// scaling to fill no matter what the size of media
				} else {
					const ratioFill = Math.max(displayWidth / 1920, displayHeight / 1080);
					this.width = 1920 * ratioFill;
					this.height = 1080 * ratioFill;
					// change position
					this.x = 0;
					this.y = 0;
				}
			}
		},
	},
	computed: {
		...mapGetters({
			user: 'user',
			clientUser: 'clientUser',
			isClient: 'isClient',
			isSuperAdmin: 'isSuperAdmin',
			isCollaborator: 'isCollaborator',
		}),
		filteredParent() {
			const filteredParent = this.items.filter(item => item.id !== this.data.id);
			let finalResult = filteredParent.filter(item => item.type !== 'separator');
			if (this.keywordSearchParent) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchParent.toUpperCase()));
				return finalResult;
			}
			if (this.keywordSearchOnComplete) {
				finalResult = finalResult.filter(item => item.name.toUpperCase().includes(this.keywordSearchOnComplete.toUpperCase()));
				return finalResult;
			}
			return finalResult;
		},
		userId() {
			const userId = this.user && this.user.id ? this.user.id : null;
			return userId;
		},
		userSettings() {
			const settings = this.user && this.user.settings ? JSON.parse(this.user.settings) : null;
			return settings;
		},
		tickerParams() {
			// const parentItemId = this.parentItem && this.parentItem.id ? this.parentItem.id : null;
			const parentItemId = this.selectedParent && this.selectedParent.id ? this.selectedParent.id : null;
			const onCompleteItemId = this.selectedOnComplete && this.selectedOnComplete.id ? this.selectedOnComplete.id : null;
			const content = {
				tickerData: this.tickerData,
				template: this.selectedTemplate,
				speed: this.speed,
				fontColor: this.fontColor,
				backgroundColor: this.backgroundColor,
				gradient: this.gradient,
				angle: this.angle,
				label: this.label,
				layerIndex: this.layerIndex,
				width: this.width,
				height: this.height,
				position: this.position,
				isRatio: this.isRatio,
				isPosition: this.isPosition,
				x: this.x,
				y: this.y,
				displayTime: this.displayTime,
				hardGradient: this.hardGradient,
				title: this.title,
				fontStyle: this.fontStyle,
				type: this.type,
				isParent: this.isParent,
				parentItem: parentItemId,
				onCompleteItem: onCompleteItemId,
				childOrder: this.childOrder,
				blendMode: this.blendMode,
				// uploaded ticker data
				mediaAssetLabel: this.mediaAssetLabel,
				assetsURL: this.mediaAsset,
				opacity: this.opacity / 100,
			};
			const contentString = JSON.stringify(content);
			const params = {
				name: this.label || 'Default Ticker',
				type: this.type,
				content: contentString,
				layer_index: this.layerIndex,
				rundown_id: this.rundownId,
				// status: 1,
				// is_play_live: 0,
				// is_play_preview: 0,
				// is_shy: 0,
			};
			if (!this.data.active_edit) {
				params.active_edit = this.userId;
			}
			return params;
		},
		rundownId() {
			return this.rundown ? this.rundown.id : 0;
		},
		isIndexDuplicated() {
			if (this.data) {
				// eslint-disable-next-line
				const filter = (({ id, layer_index }) => id !== this.data.id && layer_index === this.layerIndex);
				const duplicateItems = this.items.filter(filter);
				return duplicateItems.length > 0;
			}
			return false;
		},
		isLocked() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index];
		},
		labelFont() {
			let content = this.data.content;
			if (typeof content === 'string') {
				content = JSON.parse(content);
			}
			if (content && content.fontStyle >= 0) {
				const index = this.fontOptions.findIndex(({ key }) => key === JSON.stringify(content.fontStyle));
				if (index !== -1) return this.fontOptions[index].label;
			}
			return this.fontOptions[0].label;
		},
		filteredFont() {
			if (this.searchFont) {
				return this.fontOptions.filter(item => item.label.toLowerCase().includes(this.searchFont));
			}
			return this.fontOptions;
		},
		content() {
			let content = null;
			if (this.data) {
				content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
			}
			return content;
		},
		checkAssets() {
			return this.content && this.content.assetsURL ? this.content.assetsURL.length > 0 : false;
		},
		rundownStorage() {
			return {
				total_max_file_size: this.rundown && this.rundown.total_max_file_size ? this.rundown.total_max_file_size : 0,
				total_remaining_size: this.rundown && this.rundown.total_remaining_size ? this.rundown.total_remaining_size : 0,
				total_used_file_size: this.rundown && this.rundown.total_used_file_size ? this.rundown.total_used_file_size : 0,
			};
		},
		isUserEditing() {
			const index = this.items.findIndex(({ id }) => id === this.data.id);
			return this.items[index] ? this.items[index].active_edit : null;
		},
	},
	watch: {
		fontStyle() {
			this.searchFont = '';
		},
		template() {
			if (this.template) {
				if (this.selectedTemplate !== this.template) {
					this.selectedTemplate = this.template;
					this.onKeywordChange();
				}
			}
		},

		data() {
			if (this.data) {
				let content = this.data.content;
				if (typeof content === 'string') {
					content = JSON.parse(content);
				}
				this.label = this.data.name;
				this.layerIndex = this.data.layer_index;
				const activeEdit = this.data.active_edit;
				if (activeEdit && activeEdit !== this.userId) {
					this.isActiveEdit = true;
					// this.initData();
				} else {
					this.isActiveEdit = false;
				}
				if (content) {
					if (content.template) {
						this.selectedTemplate = content.template;
						this.$emit('setTemplate', this.selectedTemplate);
						// this.lottiedatachange(this.selectedTemplate);
					}
					if (content.tickerData) {
						this.tickerData = content.tickerData;
					}
					this.speed = content.speed;
					this.fontColor = content.fontColor;
					this.backgroundColor = content.backgroundColor;
					this.gradient = content.gradient;
					this.angle = content.angle;
					this.width = content.width;
					this.height = content.height;
					this.position = content.position;
					this.isRatio = content.isRatio;
					this.isPosition = content.isPosition;
					this.x = content.x;
					this.y = content.y;
					this.displayTime = content.displayTime;
					this.hardGradient = content.hardGradient;
					this.title = content.title;
					this.fontStyle = content.fontStyle;
					this.isParent = content.isParent || false;
					// this.parentItem = this.filteredItems.find(item => item.id === content.parentItem) || '';
					this.selectedParent = this.filteredItems.find(item => item.id === content.parentItem) || '';
					this.selectedOnComplete = this.filteredParent.find(item => item.id === content.onCompleteItem) || '';

					this.childOrder = content.childOrder;
					this.blendMode = content.blendMode;
					// uploaded ticker data
					this.mediaAssetLabel = content.mediaAssetLabel;
					this.mediaAsset = content.assetsURL;
					this.extractedTicker = content.extractedTicker;
					this.opacity = content.opacity * 100;
				}
			}
		},
	},
	beforeDestroy() {
		if (this.data.active_edit === this.userId) {
			this.updateActiveEdit();
		}
	},
	created() {
		if (this.clientUser) {
			this.localClientUser = this.clientUser;
		}
		this.isRequired = false;
		this.$nextTick(() => {
			this.initData();
		});
		this.isLoading = true;
		setTimeout(() => {
			this.isRequired = true;
			this.isLoading = false;
		}, 400);
	},
};
</script>
